import { set } from 'lodash-es'
import setProp from '@/js/helper/set-prop.js'

import { CHECKOUT_CONSTANTS, CHECKOUT_PATHS } from '../constants/checkout-constants'
import CONSTANTS from '../constants'
import MUTATION_TYPE from '../mutation-types/generated-checkout-mutation-types'
import BASKET_MUTATION_TYPE from '../mutation-types/basket-mutation-types'
import { v1 as uuidv1 } from 'uuid'

export default Object.keys(MUTATION_TYPE).reduce(
  (mutationTypes, type) => ({
    ...mutationTypes,
    [type]: (state, value) => {
      console.log(
        '🚀 ~ file: checkout-mutations.js:13 ~ CHECKOUT_PATHS[type], value:',
        CHECKOUT_PATHS[type],
        value,
      )
      set(state, CHECKOUT_PATHS[type], value)
    },
  }),
  {
    [BASKET_MUTATION_TYPE.DELIVERY_ADDRESS]: (state, { client, value }) => {
      setProp(
        state,
        [...CHECKOUT_PATHS.CLIENT_DATA, client, CHECKOUT_CONSTANTS.DELIVERY_ADDRESS],
        value,
      )
    },
    [BASKET_MUTATION_TYPE.COMMENT]: (state, { client, value }) => {
      console.log('🚀 ~ file: checkout-mutations.js:51 ~ client, value:', client, value, [
        ...CHECKOUT_PATHS.CLIENT_DATA,
        CHECKOUT_CONSTANTS.COMMENT,
      ])
      if (client) {
        setProp(state, [...CHECKOUT_PATHS.CLIENT_DATA, client, CHECKOUT_CONSTANTS.COMMENT], value)
        return
      }
      setProp(state, [...CHECKOUT_PATHS.CLIENT_DATA, CHECKOUT_CONSTANTS.COMMENT], value)
    },
    [BASKET_MUTATION_TYPE.REFERENCE]: (state, { client, value }) => {
      if (client) {
        setProp(state, [...CHECKOUT_PATHS.CLIENT_DATA, client, CHECKOUT_CONSTANTS.REFERENCE], value)
        return
      }
      setProp(state, [...CHECKOUT_PATHS.CLIENT_DATA, CHECKOUT_CONSTANTS.REFERENCE], value)
    },
    [BASKET_MUTATION_TYPE.ADD_BASKET_MESSAGE]: (state, { message, type = 'basket.removed' }) => {
      const notificationType = type === 'basket.removed' ? 'warning' : 'basket'
      state[CONSTANTS.BASKET_MESSAGES].push({ id: uuidv1(), message, notificationType, type })
    },
    [BASKET_MUTATION_TYPE.REMOVE_BASKET_MESSAGE]: (state, { id }) => {
      const ids = Array.isArray(id) ? id : [id]
      ids.forEach(id => {
        const index = state[CONSTANTS.BASKET_MESSAGES].findIndex(i => i.id === id)
        if (index !== -1) {
          state[CONSTANTS.BASKET_MESSAGES].splice(index, 1)
        }
      })
    },
  },
)
